import { useEffect, useMemo } from 'react';
import { View, Pressable } from 'react-native';
import Animated, { useAnimatedStyle, useSharedValue, withTiming } from 'react-native-reanimated';
import { StyleSheet } from 'react-native-unistyles';

function PageIndicator({pageCount, currentPage }) {

    const spacing = 14;
    const translateX = useSharedValue(0);

    useEffect(() => {
        translateX.value = currentPage
    }, [currentPage])

    const animationContainerStyle = useAnimatedStyle(() => ({
        transform: [{translateX:  withTiming(translateX.value*spacing, {duration:200})}, {scale: 1.2}]
    }))

    const pageComponents = useMemo(() => {
        const dots = []
        for(let i=0; i<pageCount; i++){
            dots.push(<View
                key={i}
                // hitSlop={4} 
                // onPress={() => pagerRef.current?.setPage(i)} key={i} 
                style={styles.dot}
            ></View>)
        }
        return dots
    }, [pageCount])

    return (
        <View style={styles.container}>
            <Animated.View style={[animationContainerStyle, styles.dotActive]}></Animated.View>
            {pageComponents}
        </View>
    )
}

const styles = StyleSheet.create(({colors}) => ({
    container: {
        flexDirection:"row", 
        justifyContent:"center", 
        alignItems:"center"
    },
    dot: {
        transform: [{translateX: -14}], 
        margin:4, 
        width:6, 
        height:6, 
        borderRadius:6, 
        backgroundColor:colors.primary, 
        opacity:0.4
    },
    dotActive: {
        margin:4, 
        width:6, 
        height:6, 
        borderRadius:6, 
        backgroundColor:colors.primary
    }
}))

export default PageIndicator